export enum AccountType {
  NONE = "NONE",
  OBI_CUSTOMER = "OBI_CUSTOMER",
  HEYOBI_CUSTOMER = "HEYOBI_CUSTOMER",
  HEYOBI_PRO_CUSTOMER = "HEYOBI_PRO_CUSTOMER",
}
